import type { MRT_ColumnDef } from "mantine-react-table-open";
import { backendDateOrDateTimeToLuxonDateTimeOrNull } from "../../../utils/dates/backendDateOrDateTimeToLuxonDateTimeOrNull";
import type { Doc } from "../../DeliveryOverview/DeliveryOverview.types";
import { getDateRange } from "../getDateRange";

function getBillingPeriodColumn(): MRT_ColumnDef<Doc> {
  return {
    header: "Zeitraum",
    accessorKey: "billingPeriodStart",
    accessorFn: (row) =>
      backendDateOrDateTimeToLuxonDateTimeOrNull(
        row.invoiceData?.billingPeriodStart || null
      )?.toJSDate(),
    size: 140,
    sortingFn: "datetime",
    enableColumnFilter: false,
    Cell: ({ row }) =>
      getDateRange({
        beginDate: row.original.invoiceData?.billingPeriodStart,
        endDate: row.original.invoiceData?.billingPeriodEnd
      })
  };
}

export { getBillingPeriodColumn };
